<template>
  <v-card>
    <v-card-title>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Editar {{ editedItem.sample }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="editedItem.name"
                    label="Nombre del paciente"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="editedItem.prescriber"
                    label="Prescriptor"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="editedItem.gender"
                    label="Sexo"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="editedItem.array_id"
                    label="Array"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="editedItem.project"
                    label="Proyecto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedItem.user_hash"
                    label="Email"
                    placeholder="email@email.com"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedItem.sharing_hashes"
                    label="Emails compartidos"
                    placeholder="email1@email.com|email2@email.com"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedItem.md_hashes"
                    placeholder="email1@email.com|email2@email.com"
                    label="Emails medicos"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
              Cancelar
            </v-btn>
            <v-btn color="blue darken-1" text @click="save">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5"
            >¿Seguro que quieres eliminar la muestra
            {{ editedItem.sample }}?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
              >Eliminar</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDetail" max-width="500px">
        <v-card>
          <v-card-title class="text-h5"
            >Muestra: {{ editedItem.sample }}</v-card-title
          >
          <v-row align="center" justify="space-around">
            <div class="grey--text text--lighten-1 text-body-2 mb-4">
              Acceder a los detalles de la muestra:
            </div>
          </v-row>
          <v-row align="center" justify="space-around">
            <v-btn
              @click="
                $router.push({
                  name: 'SampleGXSnpsResults',
                  params: { sampleId: editedItem.sample }
                })
              "
              depressed
            >
              SNPs
            </v-btn>
            <v-btn
              @click="
                $router.push({
                  name: 'SampleGXDrugsResults',
                  params: { sampleId: editedItem.sample }
                })
              "
              depressed
              color="info"
            >
              Medicamentos
            </v-btn>
            <v-btn
              @click="
                $router.push({
                  name: 'SampleGXGenesResults',
                  params: { sampleId: editedItem.sample }
                })
              "
              depressed
              color="primary"
            >
              Genes
            </v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDetail"
              >Cancelar</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer></v-spacer>

      <v-col cols="3">
        <v-btn
          @click="downloadTemplate"
          color="blue-grey"
          class="ma-2 white--text"
        >
          Plantilla
          <v-icon right dark>
            mdi-cloud-download
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-select
          :items="searchableFields"
          v-model="activeFilter"
          item-text="text"
          item-value="value"
          label="Campos"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="filterSearch"
          append-icon="mdi-magnify"
          label="Filtrar"
        ></v-text-field>
      </v-col>
      <v-col cols="1">
        <S3Uploader @refresh="getDataFromApi" text="Subir muestras" />
      </v-col>
    </v-card-title>
    <v-row>
      <v-col cols="12">
        <v-combobox
          v-model="selectedFields"
          :items="allFields"
          label="Columnas"
          multiple
          chips
        ></v-combobox>
      </v-col>
    </v-row>
    <v-data-table
      :headers="selectedHeaders"
      :items="samples"
      :options.sync="options"
      multi-sort
      :server-items-length="totalSamples"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small class="mr-2" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
        <v-icon small @click="detailItem(item)">
          mdi-eye
        </v-icon>
      </template>
      <template v-slot:item.report_generated="{ item }">
        <v-icon small :color="(item.report_generated && 'green') || 'red'">
          mdi-circle
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Strapi from "@/services/Strapi.js";
import S3Uploader from "@/components/mylogy/S3Uploader.vue";
export default {
  components: {
    S3Uploader
  },
  data() {
    return {
      totalSamples: 0,
      samples: [],
      filterSearch: null,
      loading: true,
      activeFilter: "sample",
      options: {},
      editedIndex: -1,
      dialog: false,
      dialogDelete: false,
      dialogDetail: false,
      editedItem: {
        id: "",
        sample: "",
        year: "",
        array_id: "",
        user_hash: null,
        sharing_hashes: null,
        md_hashes: null,
        project: "",
        gender: "",
        name: "",
        prescriber: "",
        analysed_genes: "",
        date: ""
      },
      selectedFields: [
        "Muestra",
        "Nombre",
        "Sexo",
        "Genes Analizados",
        "Analizados",
        "Informe Generado",
        "Fecha",
        "Acciones"
      ],
      headers: [
        {
          text: "Muestra",
          align: "start",
          sortable: true,
          searchable: true,
          value: "sample"
        },
        { text: "Nombre", value: "name", sortable: false, searchable: false },
        {
          text: "Informe Generado",
          value: "report_generated",
          sortable: true,
          searchable: false
        },
        {
          text: "Fecha informe",
          value: "report_generated_at",
          sortable: true,
          searchable: false
        },
        { text: "Año", value: "year", sortable: true, searchable: true },
        { text: "Array", value: "array_id", sortable: true, searchable: true },
        {
          text: "Proyecto",
          value: "project",
          sortable: true,
          searchable: true
        },
        { text: "Sexo", value: "gender", sortable: true, searchable: true },
        {
          text: "Precriptor",
          value: "prescriber",
          sortable: true,
          searchable: true
        },
        { text: "Fecha", value: "date", sortable: true, searchable: true },
        {
          text: "Analizados",
          value: "analysed",
          sortable: true,
          searchable: false
        },
        {
          text: "Genes Analizados",
          value: "analysed_genes",
          sortable: true,
          searchable: false
        },
        {
          text: "No Analizados",
          value: "no_analysed",
          sortable: true,
          searchable: false
        },
        { text: "Acciones", value: "actions", sortable: false }
      ]
    };
  },
  computed: {
    searchableFields() {
      return this.selectedHeaders.filter(h => h.searchable);
    },
    allFields() {
      return this.headers.map(h => h.text);
    },
    selectedHeaders() {
      return this.headers.filter(h => {
        return this.selectedFields.includes(h.text);
      });
    }
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    filterSearch: {
      handler() {
        this.getDataFromApi();
      }
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogDetail(val) {
      val || this.closeDetail();
    }
  },
  methods: {
    downloadTemplate() {
      window
        .open(
          process.env.VUE_APP_IMPORT_TEMPLATE_URL,
          "_blank"
        )
        .focus();
    },
    editItem(item) {
      this.editedIndex = this.samples.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.samples.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    detailItem(item) {
      this.editedIndex = this.samples.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDetail = true;
    },
    deleteItemConfirm() {
      let self = this;
      Strapi.delete(`/gx-samples/${this.editedItem.id}`)
        .then(() => {
          self.$alertify.success("Muestra eliminada");
        })
        .catch(() => {
          self.$alertify.error("Ha ocurrido un error");
        })
        .then(() => {
          self.closeDelete();
          self.getDataFromApi();
        });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDetail() {
      this.dialogDetail = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      let self = this;
      Strapi.put(`/gx-samples/${this.editedItem.id}`, self.editedItem)
        .then(() => {
          self.$alertify.success("Muestra actualizada");
        })
        .catch(() => {
          self.$alertify.error("Ha ocurrido un error");
        })
        .then(() => {
          self.close();
          self.getDataFromApi();
        });
    },
    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const _sort = sortBy
        .map(function(e, i) {
          return `${e}:${(sortDesc[i] && "DESC") || "ASC"}`;
        })
        .join(",");
      const qs = require("qs");

      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage
      };

      if (sortBy.length > 0) {
        params._sort = _sort;
      }

      if (this.filterSearch) {
        params._where = {
          _or: [
            { FIELD: this.filterSearch },
            { FIELD_contains: this.filterSearch }
          ]
        };
      }

      const query = qs
        .stringify(params, {
          encodeValuesOnly: true
        })
        .replace(/FIELD/g, this.activeFilter);

      Strapi.get(`/gx-samples?${query}`).then(res => {
        this.samples = res.data;
        Strapi.get(`/gx-samples/count?${query}`).then(resCount => {
          this.totalSamples = resCount.data;
          this.loading = false;
        });
      });
    }
  }
};
</script>
<style lang="scss"></style>
